import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import { addLineBreaks } from "./LineBreaks";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#dff0d8",
    borderColor: "#7d8675",
    color: "#3c763d",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export default function DialogBody() {
  const classes = useStyles();
  const simActivationText = addLineBreaks(`Actions:
  Meet Non-performing/De-growing Retailers
a) Immediate Visit to De growing Retailers along with Jio Sales Team & FSE
b) Re-emphasize Margin Story & Potential Earning opportunity from Jio
c) Highlight Additional Customer benefits of Partner Brand tie ups vs Competition
d) Emphasize to keep minimum 2 Days of Wallet Balance
                `),
    jioPhoneStockText = addLineBreaks(`Action:
                1) Meet Degrowing Retailers along with Jio Sales Team & FSE
                2) Check Stock Level of Retailer & push for min 5 Jio Phones on shelf.
                3) Explain Unique Features of Jio Phone, margin story & continued higher earnings.
                                `),
    noteText = addLineBreaks(`Note:
                                1. Resolve Retailer Specific issues, Take up with Jio Team.
                                2. Retailers are shown in descending order basis Last Month SIM Activations.
                                3. Retailer Jio Phone stock is derived basis LTD Tertiary Billed minus LTD IMEI Activations: hence can be shown negative in case Jio Phone are not Billed to Retailers in Fiori system.
                                `);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Parameters</StyledTableCell>
            <StyledTableCell align="center">Red</StyledTableCell>
            <StyledTableCell align="center">Amber</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell component="th" scope="row">
              <Typography gutterBottom> Retailer Name</Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {
                  "MTD Daily average <90% of LFM daily average, N = Date -1 for daily average"
                }
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {
                  "MTD Daily average <100% of LFM daily average, N = Date -1 for daily average"
                }
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell component="th" scope="row" rowSpan={2}>
              <Typography gutterBottom>Sim Activation</Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {`MTD SIM Activation vs LMTD
                (<90%)
                `}
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {`MTD SIM Activation vs. LMTD
                (90% - 100%)
                `}
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell colSpan={2}>
              <Typography gutterBottom style={{ color: "red" }}>
                {simActivationText}
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell component="th" scope="row">
              <Typography gutterBottom>Jio Phone Activation</Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {"MTD Activation vs. LMTD (<90%)"}
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {"MTD Activation vs. LMTD (90% - 100%)"}
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell component="th" scope="row" rowSpan={2}>
              <Typography gutterBottom> Jio Phone Stock</Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {`Stock < 3 Units
                `}
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="center">
              <Typography gutterBottom>
                {`Stock 3 - 5 Units
                `}
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell colSpan={2}>
              <Typography gutterBottom style={{ color: "red" }}>
                {jioPhoneStockText}
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell component="th" scope="row" colSpan={3}>
              <Typography gutterBottom>{noteText}</Typography>
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
